export class ISPInfoForm {
  name = ''
  phoneFirstPart = ''
  phoneSecondPart = ''
  phone = ''
  email = ''
  address_cityId: number|null = null
  address_cityName = ''
  address_districtId: number|null = null
  address_districtName = ''
  address_roadId: number|null = null
  address_roadName = ''
  address_zipCode: string|null = null
  address_lane = ''
  address_semiLane = ''
  address_alley = ''
  address_semiAlley = ''
  address_number = ''
  address_semiNumber = ''
  address_floor = ''
  address_semiFloor = ''
  address_etc = ''
  note = ''
  referrer = ''
  PIIAuthorConsent = false
  installServiceConsent = false
  ispServiceContractConsent = false
  // §3.6.10 聯絡資料（隱藏地址時改填）
  contactCity = ''
  contactDistrict = ''
  contactCommunityName = ''
  preferredContactTime = ''

  public resetAddress() {
    this.address_cityId = null
    this.address_cityName = ''
    this.address_districtId = null
    this.address_districtName = ''
    this.address_roadId = null
    this.address_roadName = ''
    this.address_zipCode = null
    this.address_lane = ''
    this.address_semiLane = ''
    this.address_alley = ''
    this.address_semiAlley = ''
    this.address_number = ''
    this.address_semiNumber = ''
    this.address_floor = ''
    this.address_semiFloor = ''
    this.address_etc = ''
  }
}